import { getCourseStatusBadgeClass } from '../utils/courseDisplay';

/**
 * Badge de estatus del curso con la paleta ya usada en tarjetas/tabla.
 * @param {{ status?: string; className?: string }} props
 */
export const CourseStatusBadge = ({ status, className = '' }) => {
    if (!status) return null;

    return (
        <span
            className={`inline-flex items-center rounded-md border px-2.5 py-0.5 text-[0.7rem] font-bold uppercase tracking-wide ${getCourseStatusBadgeClass(status)} ${className}`.trim()}
        >
            {status}
        </span>
    );
};
